"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLocaleCurrency = exports.formatCurrency = void 0;
var getCurrency_1 = require("./getCurrency");
var NUMBERIC_ABBR = {
    thousand: { symbol: 'k', value: 1000 },
    million: { symbol: 'm', value: 1000000 },
    billion: { symbol: 'b', value: 1000000000 },
    trillion: { symbol: 't', value: 1000000000000 },
};
var CURRENCY_SYMBOL_MAP = new Map([
    ['pound', '\xA3'],
    ['euro', '\u20AC'],
    ['yen', '\xA5'],
]);
function abbreviateNumericValue(value) {
    var symbol = '';
    var abbrValue = value;
    if (value / NUMBERIC_ABBR.trillion.value > 1) {
        abbrValue = value / NUMBERIC_ABBR.trillion.value;
        symbol = NUMBERIC_ABBR.trillion.symbol;
    }
    else if (value / NUMBERIC_ABBR.billion.value > 1) {
        abbrValue = value / NUMBERIC_ABBR.billion.value;
        symbol = NUMBERIC_ABBR.billion.symbol;
    }
    else if (value / NUMBERIC_ABBR.million.value > 1) {
        abbrValue = value / NUMBERIC_ABBR.million.value;
        symbol = NUMBERIC_ABBR.million.symbol;
    }
    else if (value / NUMBERIC_ABBR.thousand.value > 1) {
        abbrValue = value / NUMBERIC_ABBR.thousand.value;
        symbol = NUMBERIC_ABBR.thousand.symbol;
    }
    return {
        rawValue: abbrValue,
        symbol: symbol,
        string: "" + abbrValue.toFixed(value >= 1000 ? 1 : 2) + symbol,
    };
}
function getFixedDigitCount(value, autoFixed) {
    if (value >= 1000 && autoFixed) {
        return 0;
    }
    if (value - Math.floor(value) === 0 && autoFixed) {
        return 0;
    }
    return 2;
}
function formatCurrency(value, currencyAbbr, options) {
    if (options === void 0) { options = {}; }
    var finalOptions = __assign({ autoFixed: true }, options);
    var autoFixed = finalOptions.autoFixed;
    var finalValue = value;
    if (autoFixed) {
        var parsedValue = typeof value === 'string' ? parseFloat(value) : value;
        var digitCount = getFixedDigitCount(parsedValue, autoFixed);
        finalValue = parsedValue.toFixed(digitCount);
    }
    var currency = getCurrency_1.getCurrency(currencyAbbr);
    if (currency) {
        return currency.symbolFormat
            .replace(/&(\w+);/, function (_match, p1) { return CURRENCY_SYMBOL_MAP.get(p1) || p1; })
            .replace('{#}', String(finalValue));
    }
    return finalValue + " " + currencyAbbr;
}
exports.formatCurrency = formatCurrency;
function formatLocaleCurrency(value, currency, options) {
    if (options === void 0) { options = {}; }
    var parsedValue = typeof value === 'string' ? parseFloat(value) : value;
    var finalOptions = __assign({ abbreviate: false, autoFixed: true }, options);
    var abbreviate = finalOptions.abbreviate, autoFixed = finalOptions.autoFixed;
    var locale = finalOptions.locale;
    var abbrResult = abbreviate ? abbreviateNumericValue(parsedValue) : undefined;
    var localeOptionsSupported = typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function';
    if (!localeOptionsSupported) {
        return formatCurrency(abbrResult ? abbrResult.string : parsedValue, currency, { autoFixed: !abbrResult });
    }
    if (!locale) {
        locale = typeof window !== 'undefined' && window !== null && window.navigator && window.navigator.language ? window.navigator.language : 'en-US';
    }
    var digitCount = getFixedDigitCount(parsedValue, autoFixed);
    if (abbrResult) {
        var format = abbrResult.rawValue.toLocaleString(locale, {
            minimumFractionDigits: digitCount,
            maximumFractionDigits: digitCount,
        });
        var localeCurr = abbrResult.rawValue.toLocaleString(locale, {
            minimumFractionDigits: digitCount,
            maximumFractionDigits: digitCount,
            currency: currency,
            style: 'currency',
        });
        return localeCurr.replace(format, "" + format + abbrResult.symbol);
    }
    return parsedValue.toLocaleString(locale, {
        minimumFractionDigits: digitCount,
        maximumFractionDigits: digitCount,
        currency: currency,
        style: 'currency',
    });
}
exports.formatLocaleCurrency = formatLocaleCurrency;
